import { render, staticRenderFns } from "./InformativoFormatoArquivo.vue?vue&type=template&id=17f103c4&scoped=true"
import script from "./InformativoFormatoArquivo.vue?vue&type=script&lang=js"
export * from "./InformativoFormatoArquivo.vue?vue&type=script&lang=js"
import style0 from "./InformativoFormatoArquivo.vue?vue&type=style&index=0&id=17f103c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f103c4",
  null
  
)

export default component.exports